import React from 'react';
import AuthStore from 'stores/AuthStore';
import LibraryCreateFormStore from 'stores/library/LibraryCreateFormStore';
import LibraryStore from 'stores/library/LibraryStore';
import LibraryActions from 'actions/library/LibraryActions';
import LibraryCreateActions from 'actions/library/LibraryCreateActions';
import AltContainer from 'alt-container';
import LibraryManagement from 'components/pure/admin/LibraryManagement';

export default class LibraryManagementContainer extends React.Component {
  static displayName = 'LibraryManagementContainer';

  componentDidMount() {
    LibraryActions.getLibraries(true);
    LibraryActions.getShareAccessibleDepartments();
    LibraryActions.getShareAccessibleTeams();
  }

  render() {
    return (
      <AltContainer
        actions={{LibraryActions, LibraryCreateActions}}
        stores={{AuthStore, LibraryCreateFormStore, LibraryStore}}>
        <LibraryManagement />
      </AltContainer>
    );
  }
}
